export const RepairInsuranceData = {
  Id: 1,
  Name: "Repair Insurance",
  Description: "Get Your Car Repairs Covered At Just AED 100 Per Month",
  Description2: "Covers your car for 20,000 KM or 6 Months.",
  ValidDays: 182,
  MaxCost: 1149.0,
  MinCost: 710.0,
  Cost: 1200,
  Slug: "repair",
  ImgUrl:
    "https://i.pinimg.com/736x/fe/e8/86/fee886d7ab2b8682c70140a2d4bf792d.jpg",
  InfoLines: [
    {
      Description: "No labor charges on all your wear-n-tear repairs",
    },
    {
      Description: "Covers all repairs",
    },
    {
      Description: "Annual Package",
    },
  ],
  VariantItems: null,
  ValidKm: 20000.0,
};

export const RepairInsuranceCheck = 10;
